/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const GRIP_PATH =
  'M1.16667 9.33333C0.845833 9.33333 0.571181 9.2191 0.342708 8.99063C0.114236 8.76215 0 8.4875 0 8.16667C0 7.84583 0.114236 7.57118 0.342708 7.34271C0.571181 7.11424 0.845833 7 1.16667 7C1.4875 7 1.76215 7.11424 1.99063 7.34271C2.2191 7.57118 2.33333 7.84583 2.33333 8.16667C2.33333 8.4875 2.2191 8.76215 1.99063 8.99063C1.76215 9.2191 1.4875 9.33333 1.16667 9.33333ZM4.66667 9.33333C4.34583 9.33333 4.07118 9.2191 3.84271 8.99063C3.61424 8.76215 3.5 8.4875 3.5 8.16667C3.5 7.84583 3.61424 7.57118 3.84271 7.34271C4.07118 7.11424 4.34583 7 4.66667 7C4.9875 7 5.26215 7.11424 5.49062 7.34271C5.7191 7.57118 5.83333 7.84583 5.83333 8.16667C5.83333 8.4875 5.7191 8.76215 5.49062 8.99063C5.26215 9.2191 4.9875 9.33333 4.66667 9.33333ZM1.16667 5.83333C0.845833 5.83333 0.571181 5.7191 0.342708 5.49062C0.114236 5.26215 0 4.9875 0 4.66667C0 4.34583 0.114236 4.07118 0.342708 3.84271C0.571181 3.61424 0.845833 3.5 1.16667 3.5C1.4875 3.5 1.76215 3.61424 1.99063 3.84271C2.2191 4.07118 2.33333 4.34583 2.33333 4.66667C2.33333 4.9875 2.2191 5.26215 1.99063 5.49062C1.76215 5.7191 1.4875 5.83333 1.16667 5.83333ZM4.66667 5.83333C4.34583 5.83333 4.07118 5.7191 3.84271 5.49062C3.61424 5.26215 3.5 4.9875 3.5 4.66667C3.5 4.34583 3.61424 4.07118 3.84271 3.84271C4.07118 3.61424 4.34583 3.5 4.66667 3.5C4.9875 3.5 5.26215 3.61424 5.49062 3.84271C5.7191 4.07118 5.83333 4.34583 5.83333 4.66667C5.83333 4.9875 5.7191 5.26215 5.49062 5.49062C5.26215 5.7191 4.9875 5.83333 4.66667 5.83333ZM1.16667 2.33333C0.845833 2.33333 0.571181 2.2191 0.342708 1.99063C0.114236 1.76215 0 1.4875 0 1.16667C0 0.845833 0.114236 0.571181 0.342708 0.342708C0.571181 0.114236 0.845833 0 1.16667 0C1.4875 0 1.76215 0.114236 1.99063 0.342708C2.2191 0.571181 2.33333 0.845833 2.33333 1.16667C2.33333 1.4875 2.2191 1.76215 1.99063 1.99063C1.76215 2.2191 1.4875 2.33333 1.16667 2.33333ZM4.66667 2.33333C4.34583 2.33333 4.07118 2.2191 3.84271 1.99063C3.61424 1.76215 3.5 1.4875 3.5 1.16667C3.5 0.845833 3.61424 0.571181 3.84271 0.342708C4.07118 0.114236 4.34583 0 4.66667 0C4.9875 0 5.26215 0.114236 5.49062 0.342708C5.7191 0.571181 5.83333 0.845833 5.83333 1.16667C5.83333 1.4875 5.7191 1.76215 5.49062 1.99063C5.26215 2.2191 4.9875 2.33333 4.66667 2.33333Z';

const GRIP_VIEWBOX_W = 6;
const GRIP_VIEWBOX_H = 10;

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** Six-dot drag grip (6×10 Figma tile library). Color via `currentColor`. */
const DragGripIcon = ({
  size = 10,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const height = size;
  const width = Math.round((size * GRIP_VIEWBOX_W) / GRIP_VIEWBOX_H);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${GRIP_VIEWBOX_W} ${GRIP_VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path d={GRIP_PATH} fill="currentColor" />
    </svg>
  );
};

DragGripIcon.propTypes = iconPropTypes;

export default DragGripIcon;
